<template>
  <div
    class="w-fit font-roboto text-[18px] font-normal leading-[18px] text-new-test-black xl:text-[20px] xl:leading-[24px]"
    :class="{ 'required-field': required }"
    v-bind="attrs"
  >
    {{ label }}
  </div>
  <slot></slot>
</template>

<script setup>
defineProps({
  label: {
    type: String,
    default: '',
  },
  required: {
    type: Boolean,
    default: false,
  },
});

const attrs = useAttrs();
</script>
